<template>
  <div>
    <div class="table-wapper" ref="toolbarTable">
      <table :key="keyTable">
        <thead>
          <tr class="tittle-table">
            <th class="min_width">{{ $t('outlet') }}</th>
            <th class="min_width">{{ $t('cashier') }}</th>
            <th class="report_total">{{ $t('Sales person') }}</th>
            <th class="report_date">{{ $t('date') }}</th>
            <th>{{ $t('order_id') }}</th>
            <th>{{ $t('order_number') }}</th>
            <th class="report_shift" v-if="getPlatform() === 'kidzania'">{{ $t('Shift') }}</th>
            <th>{{ $t('sku') }}</th>
            <th class="report_name">{{ $t('product_name') }}</th>
            <th v-if="getPlatform() === 'kidzania'">{{ $t('Category') }}</th>
            <th class="text-center">{{ $t('quantity') }}</th>
            <th class="report_total">{{ $t('total') }}</th>
            <th class="report_total">{{ $t('tax') }}</th>
            <th class="report_total">{{ $t('Total (Tax excluded)') }}</th>
            <th class="report_total">{{ $t('Discount') }}</th>
            <!-- <th v-if="getPlatform() === 'msi'">{{ $t('order_status') }}</th> -->
            <th>{{ $t('Note') }}</th>
            <th>{{ $t('payment_status') }}</th>
            <div v-frag v-for="(i, index) in report.paymentsCount" :key="`paymentHead${index}`">
              <th :key="`paymentNameHead${index}`">{{ $t('payment_method_name') }} {{ index + 1 }}</th>
              <th :key="`paymentAmountHead${index}`">{{ $t('payment_method_amount') }} {{ index + 1 }}</th>
              <th :key="`paymentDateHead${index}`">{{ $t('payment_method_date') }} {{ index + 1 }}</th>
              <th :key="`paymentRefHead${index}`">{{ $t('Payment reference') }} {{ index + 1 }}</th>
              <th :key="`paymentNoteHead${index}`">{{ $t('payment_method_note') }} {{ index + 1 }}</th>
            </div>
          </tr>
        </thead>
        <tbody v-if="!!report.items">
          <tr v-for="(item, index) in report.items" :key="index">
            <td>{{ item.outletName }}</td>
            <td>{{ item.cashier }}</td>
            <td>{{ item.salesman }}</td>
            <td>{{ formartDate(item.createdAt) }}</td>
            <td>{{ item.entityID }}</td>
            <td>{{ item.incrementID }}</td>
            <td v-if="getPlatform() === 'kidzania'">{{ item.shiftName }}</td>
            <td>{{ item.sku }}</td>
            <td>{{ item.name }}</td>
            <td v-if="getPlatform() === 'kidzania'">{{ item.productCategory }}</td>
            <td class="text-center">{{ item.quantity }}</td>
            <td class="text-right">{{ formatTotal(item.totalPrice, item) }}</td>
            <td class="text-right">{{ formatTotal(item.tax, item) }}</td>
            <td class="text-right">{{ formatTotal(item.subtotalPrice, item) }}</td>
            <td class="text-right">{{ formatTotal(item.totalDiscount, item) }}</td>
            <!-- <td class="text-right text-capitalize" v-if="getPlatform() === 'msi'">{{ 123 }}</td> -->
            <td class="pre-line" :class="`${item.note ? 'report_note' : ''}`">{{ item.note }}</td>
            <td class="text-right text-capitalize">{{ getPaymentStatus(item.paymentStatus) }}</td>
            <div v-frag v-for="(i, position) in report.paymentsCount" :key="`paymentData${index + position}`">
              <td :key="`paymentNameData${index + position}`" class="text-center">{{ item[`paymentName_${position + 1}`] }}</td>
              <td :key="`paymentAmountData${index + position}`" class="text-right">{{ item[`paymentName_${position + 1}`] ? formatTotal(item[`amount_${position + 1}`], item) : '' }}</td>
              <td :key="`paymentDateData${index + position}`" class="text-right">{{ item[`paymentName_${position + 1}`] ? formartDate(item[`processedAt_${position + 1}`]) : '' }}</td>
              <td :key="`paymentRefData${index + position}`" class="text-right">{{ item[`ref_${position + 1}`] }}</td>
              <td :key="`paymentNoteData${index + position}`" class="text-right">{{ item[`note_${position + 1}`] }}</td>
            </div>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pagination" v-if="count_items / getQuery.limit > 1">
      <Pagination :page="getQuery.page - 1" :total="count_items" :limit="getQuery.limit" @getDataTable="getDataTable"/>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
// import currencyFormatter from 'currency-formatter'
import paymentStatus from '@/constants/paymentStatus'
import orderStatus from '@/constants/orderStatus'
import formatNum from 'format-num'
import { getItemByLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'
import Pagination from '@/components/UiPagination'
import reportType from '@/config/reportType'
export default {
  name: 'UItableSellReport',
  components: {
    Pagination
  },
  props: {
    report: {
      type: Object
    }
  },
  data () {
    return {
      keyTable: 0
    }
  },
  computed: {
    ...mapGetters({
      getListOutLet: 'outlet/getListOutLet',
      count_items: 'report/getCountItems',
      getQuery: 'report/getQuery',
      getIsChangeStore: 'report/getIsChangeStore'
    })
  },
  watch: {
    getQuery: function (news, old) {
      if (news.page !== old.page) {
        this.$refs.toolbarTable.scrollTop = 0
      }
      if (!this.getIsChangeStore) {
        this.report.items = []
      }
      this.keyTable = Math.random()
      this.setChangeStore(false)
    }
  },
  methods: {
    ...mapActions({
      getReport: 'report/getReportDataByStore',
      setChangeStore: 'report/setChangeStore'
    }),
    formartDate (date) {
      return moment(date).format('MMMM Do YYYY HH:mm')
    },
    formatTotal (total, item = null) {
      const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
      const currentCurrent = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)
      const toCurrency = currentCurrent?.toCurrency
      var rate = item && item.presentmentCurrency && item.currencyExchangeRate && (toCurrency === item.presentmentCurrency) ? item.currencyExchangeRate : (currentCurrent?.rate || '1')
      return `${currentCurrent?.symbol || storeConfig.symbol} ${formatNum((Number(total) * Number(rate)).toFixed(2), { maxFraction: 2 })}`
    },
    getPlatform () {
      return getItemByLocalStorage(localStorageKey.CURRENT_PLATFORM)
    },
    getPaymentStatus (code) {
      if (code === null || code === undefined) {
        return ''
      }
      return paymentStatus[code] || code.split('_').join(' ')
    },
    getStatus (code) {
      const customStatus = (this.getCustomStatuses || []).find(status => status.value === code && status.is_published)
      if (customStatus) {
        return customStatus.label
      }
      return orderStatus[code] || code.split('_').join(' ')
    },
    getDataTable (currentPage) {
      this.getReport({
        type: reportType.products,
        query: {
          ...this.getQuery,
          page: currentPage
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.table-wapper {
  overflow-x: auto;
  table {
    width: 100%;
    color: #333;
    border: 0 solid #e4e3e4;
    border-collapse: collapse;
    border-spacing: 0;
    background-color: #fff;
    border-width: 1px 0 0 1px;
    border-radius: 7px;
    letter-spacing: 0;
    font-size: 15px;
    font-weight: 400;
    td,
    tr,
    th {
      border: 1px solid #e4e3e4;
      padding: 8px;
      vertical-align: middle;
    }
    .tittle-table {
      color: #fff;
      background-color: #92a1ab;
      border-top-left-radius: 7px;
      border-top-right-radius: 7px;
      th {
        font-size: 16px;
        text-transform: capitalize;
        border-bottom-width: 1px;
        padding-top: 2px;
        text-align: center;
        padding: 5px;
        border: 1px solid #e4e3e4;
        vertical-align: middle;
      }
    }
    .text-center {
      text-align: center;
    }
    .text-right {
      text-align: right;
    }
    .min_width {
      min-width: 150px;
    }
    .report_date {
      min-width: 140px;
    }
    .report_name {
      min-width: 230px;
    }
    .report_total {
      width: 100px;
    }
    .report_note {
      width: 150px;
    }
    .report_shift {
      min-width: 100px;
    }
    .pre-line {
      white-space: pre-line;
    }
  }
}
</style>
